import React from 'react';
import { Button } from '@mui/material';

const styles = {
  root: {
    background: 'rgba(0, 0, 0, 0.75)',
    color: '#FFF',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '12px 16px',
    borderRadius: 'inherit',
    gap: '8px',
    cursor: 'pointer',
  },
};

export default function UpgradeToPremiumMessage() {
  const handleUpgradeClick = (e) => {
    e?.stopPropagation();
    window.dispatchEvent(new CustomEvent('open-plan-price'));
  };

  return (
    <div style={styles.root} onClick={handleUpgradeClick}>
      <span style={{ fontWeight: 600, fontSize: '13px', lineHeight: 1.3 }}>
        Profit / Loss calculation is not available
      </span>
      <Button
        variant="contained"
        size="small"
        onClick={handleUpgradeClick}
        sx={{
          backgroundColor: '#1d6df2',
          color: '#ffffff',
          textTransform: 'none',
          fontWeight: 700,
          borderRadius: '50px',
          padding: '4px 16px',
          fontSize: '12px',
          boxShadow: '0 4px 12px rgba(29, 109, 242, 0.4)',
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: '#1557b0',
          },
        }}
      >
        Upgrade Plan
      </Button>
    </div>
  );
}

